<template>
  <div>
    <div class="text-sm-right mb-4">
      <v-btn
        v-if="checkAuthorization('department_create')"
        class="primary mx-0"
        @click="addNewDepartment"
      >
        <v-icon>mdi-plus</v-icon>Thêm
      </v-btn>
    </div>

    <v-simple-table class="table-layout pa-5">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="th-id">
              #
            </th>
            <th>Tên phòng ban</th>
            <th>Nhóm ngành</th>
            <th>Mô tả</th>
            <th v-if="showAction">Thao tác</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(department, index) in departments">
            <tr
              :key="department.id"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ _.get(department, 'name') }}</td>
              <td>{{ getSchoolLevel(_.get(department, 'schoolLevel', [])) }}
              <td>{{ _.get(department, 'description') }}</td>
              <td v-if="showAction">
                <div class="action">
                    <v-tooltip bottom v-if="checkAuthorization('department_update')">
                        <template v-slot:activator="{ on }">
                            <v-btn class="mr-2"  @click="editDepartment(department)" icon small color="primary" dark v-on="on"><v-icon>mdi-pencil</v-icon></v-btn>
                        </template>
                        <span>Cập nhật thông tin phòng ban</span>
                    </v-tooltip>
                    <v-tooltip bottom v-if="checkAuthorization('department_delete')">
                        <template v-slot:activator="{ on }">
                            <v-btn @click="onClickDelete(department)" icon small color="default" v-on="on"><v-icon>mdi-delete</v-icon></v-btn>
                        </template>
                        <span>Xóa phòng ban</span>
                    </v-tooltip>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </template>
    </v-simple-table>
    <department-form :schoolLevels="schoolLevels" />
  </div>
</template>
<script>
  import DepartmentForm from './DepartmentForm.vue'
  import RepositoryFactory from '../../../repositories/RepositoryFactory'

  const DepartmentRepository = RepositoryFactory.get('department')
  export default {
    components: { DepartmentForm },
    props: {
      filterForm: {
        type: Object,
        default: () => {},
      },
      departments: {
        type: Array,
        default: () => [],
      },
      schoolLevels: {
        type: Array,
        default: () => []
      }
    },
    data () {
      return {
        selectedDepartment: {},
        modalAlert: false,
        errorMessage: '',
      }
    },
    created () {
    },
    computed: {
      showAction () {
        return this.checkAuthorization('department_update') || this.checkAuthorization('department_delete');
      }
    },
    methods: {
      addNewDepartment () {
        this.selectedDepartment = {}
        Bus.$emit('department-show-form', this.selectedDepartment)
      },
      editDepartment (department) {
        this.selectedDepartment = department
        Bus.$emit('department-show-form', this.selectedDepartment)
      },
      async onClickDelete (department) {
        this.$swal({
          title: 'Xóa phòng ban',
          text: 'Bạn có thực sự muốn xóa ?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Đồng ý',
          cancelButtonText: 'Hủy bỏ',
        }).then(async (result) => {
          if (result.value) {
            const loader = this.$loading.show()
            const respond = await DepartmentRepository.delete(department.id)
            loader.hide()
            if (_.get(respond, 'success', false)) {
              this.$swal({
                title: 'Đã xóa thành công !',
                confirmButtonText: 'Đồng ý',
              },
              ).then(() => {
                  Bus.$emit('department-list-reload')
              })
            } else {
              this.$swal({
                type: 'error',
                title: 'Lỗi !',
                text: _.get(respond, 'message', ''),
              })
            }
          }
        })
      },
      getSchoolLevel(array) {
        let ids = array.map(item => item.id)
        if (!_.isEmpty(this.schoolLevels)) {
          let schoolLevelFilter = this.schoolLevels.filter(item => ids.includes(item.id))
          schoolLevelFilter = schoolLevelFilter.map(item => item.name)
          
          if(schoolLevelFilter) {
            return schoolLevelFilter.join(", ")
          }
        }

        return ''
      }
    },
  }
</script>
